import { Button } from "@blueprintjs/core";
import React from "react";

import { ERoutes } from "../../AppRouter";
import { useNavigationContext } from "../../contexts";
import { useTl } from "../../hooks";

import styled from "styled-components";

interface IBackButtonProps {
  backRoute: ERoutes | string;
}

const StyledButton = styled(Button)`
  margin-bottom: 0.5rem !important;
`;

export const BackButton: React.FunctionComponent<IBackButtonProps> = ({
  backRoute,
}) => {
  const { t } = useTl();
  const { goBack } = useNavigationContext();

  return (
    <StyledButton
      title={`${t("GoBack")}`}
      icon="arrow-left"
      intent="primary"
      minimal={true}
      onClick={() => goBack(backRoute)}
    />
  );
};
